import API from "../../api/api";


const callApi = async (endpoint) => {
    try {
        const response = await API.get(endpoint);
        if (response.status === 200) {
            return response?.data?.data;
        } else {
            return response?.data?.data;
        }
    } catch (error) {
        console.log(error);
        throw error;
    }
};

const LoginService = {
    authAccess: async (data) => {
        return API.post("auth/access", JSON.stringify(data))
            .then((response) => response.data)
            .catch((error) => Promise.reject(error));
    },
    verify2faOtp:async (data) => {
        return API.post("auth/verify-twofa-otp", JSON.stringify(data))
            .then((response) => response.data)
            .catch((error) => Promise.reject(error));
    },
    logout: async () => {
        return API.post("/auth/logout")
            .then((response) => response.data)
            .catch((error) => Promise.reject(error));
    },
    forgotPassword: async (data) => {
        return API.post("/auth/forgot-password", JSON.stringify(data))
            .then((response) => response.data)
            .catch((error) => Promise.reject(error));
    },
    verifyForgotPassword: async (data) => {
        return API.post('/auth/verify-forgot-password', data)
            .then((response) => response)
            .catch((error) => Promise.reject(error));
    },
    changeForgotPassword: async (data) => {
        return API.post('/auth/update-password', data)
            .then((response) => response.data)
            .catch((error) => Promise.reject(error));
    },
    verifyEmail: async (username, adminUsername) => {
        return API.post(`auth/email-verification?encryptedUsername=${username}&encryptedAdminUsername=${adminUsername}`)
    },
    companyLogo: async () => {
        return callApi('/auth/get-company-logo')
    },
    createPaypalOrder: async (data) => {
        return API.post('/auth/create-paypal-order', data)
            .then((response) => response.data)
            .catch((error) => Promise.reject(error));
    },
    capturePaypalOrder:async (data) => {
        return API.post('/auth/capture-paypal-order', data)
            .then((response) => response.data)
            .catch((error) => Promise.reject(error));
    },
    PaymentReport: async (page, limit, sortBy, direction) => {
        return API.get(`/my-payment-report?page=${page}&perPage=${limit}&sortBy=${sortBy}&direction=${direction}`)
            .then((response) => response.data)
            .catch((error) => Promise.reject(error));
    },
    getSubscriptionDetails: async () => {
        return API.get('/subscription-details')
            .then((response) => response.data)
            .catch((error) => Promise.reject(error));
    },
    manageSubscription: async (data) => {
        return API.post('/manage-subscription', data)
            .then((response) => response.data)
            .catch((error) => Promise.reject(error));
    },
}

export default LoginService
